import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
export const useDecitraitDose = (dose) => {
    const { t } = useIntl();
    const roundedDose = !isNil(dose) ? Math.round((dose + Number.EPSILON) * 100) / 100 : '-';
    const unit = t('dss.decitrait.inputs.millilitersOrGramsPerHectar');
    const formattedDose = `${roundedDose} ${unit}`;
    return formattedDose;
};
